/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::1e1c80a5700235c55449aa23948418be>>
 * @codegenCommand yarn build tokens
 */

var themeImportsMap = {
  'light': function light() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-light" */
    './themes/atlassian-light');
  },
  'dark': function dark() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-dark" */
    './themes/atlassian-dark');
  },
  'legacy-light': function legacyLight() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-legacy-light" */
    './themes/atlassian-legacy-light');
  },
  'legacy-dark': function legacyDark() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-legacy-dark" */
    './themes/atlassian-legacy-dark');
  },
  'spacing': function spacing() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-spacing" */
    './themes/atlassian-spacing');
  },
  'typography-adg3': function typographyAdg3() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-typography-adg3" */
    './themes/atlassian-typography-adg3');
  },
  'shape': function shape() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-shape" */
    './themes/atlassian-shape');
  },
  'light-new-input-border': function lightNewInputBorder() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-light-new-input-border" */
    './themes/atlassian-light-new-input-border');
  },
  'dark-new-input-border': function darkNewInputBorder() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-dark-new-input-border" */
    './themes/atlassian-dark-new-input-border');
  },
  'typography': function typography() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-typography" */
    './themes/atlassian-typography');
  },
  'typography-minor3': function typographyMinor3() {
    return import( /* webpackChunkName: "@atlaskit-internal_atlassian-typography-minor3" */
    './themes/atlassian-typography-minor3');
  }
};
export default themeImportsMap;